var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-charts',{ref:"line",attrs:{"autoresize":"","options":_vm.line,"theme":"theme-color","auto-resize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }